export default __webpack_public_path__ + "static/media/relevant-info-person.18e7ce27.svg";